import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../config/settings";
import httpRequest from "../../utils/httpRequest";

const initialState = {
  user: null,
};

export const createsendPassword = createAsyncThunk(
  "user/sendPassword",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/Account/send-reset-password-otp/${arg}`,
        "post",
       
      );
      if (response?.response?.data) {
        return response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createresetPassword = createAsyncThunk(
  "user/resetPassword",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/Account/reset-password`,
        "post",
        arg,
       
      );
      if (response?.response?.data) {
        return response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);



const authSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    addLoginUser: (state, { payload }) => {
      // console.log("auth poayload",{ payload });
      state.user = payload;

    },
    removeUser: (state) => {
      state.user = null;
    },
  },
});

export default authSlice.reducer;
export const { removeUser, addLoginUser } = authSlice.actions;
